import { render, staticRenderFns } from "./HelpText.vue?vue&type=template&id=8c993dcc&"
import script from "./HelpText.vue?vue&type=script&lang=js&"
export * from "./HelpText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports